"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { Drop as DropType, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropSize } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { useMemo } from "react";
import DropContext from "./DropContext";
import type { DropIdentityMode, DropInteractionParams, DropLocation } from "./drop.types";
import ParticipationDrop from "./participation/ParticipationDrop";
import WaveDrop from "./WaveDrop";
import WinnerDrop from "./winner/WinnerDrop";
export type { DropInteractionParams } from "./drop.types";
export { DropLocation } from "./drop.types";
interface DropProps {
  readonly drop: ExtendedDrop;
  readonly previousDrop: DropType | null;
  readonly nextDrop: DropType | null;
  readonly showWaveInfo: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly dropViewDropId: string | null;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onReplyClick: (serialNo: number) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly parentContainerRef?: React.RefObject<HTMLElement | null> | undefined;
  readonly wrapContentOnly?: (content: React.ReactNode) => React.ReactNode;
  readonly identityMode?: DropIdentityMode | undefined;
  readonly showInteractions?: boolean | undefined;
}
export default function Drop(t0) {
  const $ = _c(54);
  const {
    drop,
    previousDrop,
    nextDrop,
    showWaveInfo,
    activeDrop,
    location,
    dropViewDropId,
    onReply,
    onReplyClick,
    onQuoteClick,
    onDropContentClick,
    showReplyAndQuote,
    parentContainerRef,
    wrapContentOnly,
    identityMode,
    showInteractions: t1
  } = t0;
  const showInteractions = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== activeDrop || $[1] !== drop || $[2] !== identityMode || $[3] !== location || $[4] !== onDropContentClick || $[5] !== onQuoteClick || $[6] !== onReply || $[7] !== parentContainerRef || $[8] !== showInteractions || $[9] !== showReplyAndQuote || $[10] !== showWaveInfo) {
    t2 = <ParticipationDrop drop={drop} showWaveInfo={showWaveInfo} activeDrop={activeDrop} location={location} onReply={onReply} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} showReplyAndQuote={showReplyAndQuote} parentContainerRef={parentContainerRef} identityMode={identityMode} showInteractions={showInteractions} />;
    $[0] = activeDrop;
    $[1] = drop;
    $[2] = identityMode;
    $[3] = location;
    $[4] = onDropContentClick;
    $[5] = onQuoteClick;
    $[6] = onReply;
    $[7] = parentContainerRef;
    $[8] = showInteractions;
    $[9] = showReplyAndQuote;
    $[10] = showWaveInfo;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== activeDrop || $[13] !== drop || $[14] !== dropViewDropId || $[15] !== identityMode || $[16] !== location || $[17] !== nextDrop || $[18] !== onDropContentClick || $[19] !== onQuoteClick || $[20] !== onReply || $[21] !== onReplyClick || $[22] !== parentContainerRef || $[23] !== previousDrop || $[24] !== showInteractions || $[25] !== showReplyAndQuote || $[26] !== showWaveInfo) {
    t3 = <WinnerDrop drop={drop} previousDrop={previousDrop} nextDrop={nextDrop} showWaveInfo={showWaveInfo} activeDrop={activeDrop} location={location} dropViewDropId={dropViewDropId} onReply={onReply} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} showReplyAndQuote={showReplyAndQuote} parentContainerRef={parentContainerRef} identityMode={identityMode} showInteractions={showInteractions} />;
    $[12] = activeDrop;
    $[13] = drop;
    $[14] = dropViewDropId;
    $[15] = identityMode;
    $[16] = location;
    $[17] = nextDrop;
    $[18] = onDropContentClick;
    $[19] = onQuoteClick;
    $[20] = onReply;
    $[21] = onReplyClick;
    $[22] = parentContainerRef;
    $[23] = previousDrop;
    $[24] = showInteractions;
    $[25] = showReplyAndQuote;
    $[26] = showWaveInfo;
    $[27] = t3;
  } else {
    t3 = $[27];
  }
  const t4 = previousDrop?.type === DropSize.FULL ? previousDrop : null;
  const t5 = nextDrop?.type === DropSize.FULL ? nextDrop : null;
  let t6;
  if ($[28] !== activeDrop || $[29] !== drop || $[30] !== dropViewDropId || $[31] !== identityMode || $[32] !== location || $[33] !== onDropContentClick || $[34] !== onQuoteClick || $[35] !== onReply || $[36] !== onReplyClick || $[37] !== showInteractions || $[38] !== showReplyAndQuote || $[39] !== showWaveInfo || $[40] !== t4 || $[41] !== t5 || $[42] !== wrapContentOnly) {
    t6 = <WaveDrop drop={drop} previousDrop={t4} nextDrop={t5} showWaveInfo={showWaveInfo} activeDrop={activeDrop} location={location} dropViewDropId={dropViewDropId} onReply={onReply} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} showReplyAndQuote={showReplyAndQuote} wrapContentOnly={wrapContentOnly} identityMode={identityMode} showInteractions={showInteractions} />;
    $[28] = activeDrop;
    $[29] = drop;
    $[30] = dropViewDropId;
    $[31] = identityMode;
    $[32] = location;
    $[33] = onDropContentClick;
    $[34] = onQuoteClick;
    $[35] = onReply;
    $[36] = onReplyClick;
    $[37] = showInteractions;
    $[38] = showReplyAndQuote;
    $[39] = showWaveInfo;
    $[40] = t4;
    $[41] = t5;
    $[42] = wrapContentOnly;
    $[43] = t6;
  } else {
    t6 = $[43];
  }
  let t7;
  if ($[44] !== t2 || $[45] !== t3 || $[46] !== t6) {
    t7 = {
      [ApiDropType.Participatory]: t2,
      [ApiDropType.Winner]: t3,
      [ApiDropType.Chat]: t6
    };
    $[44] = t2;
    $[45] = t3;
    $[46] = t6;
    $[47] = t7;
  } else {
    t7 = $[47];
  }
  const components = t7;
  let t8;
  if ($[48] !== drop || $[49] !== location) {
    t8 = {
      drop,
      location
    };
    $[48] = drop;
    $[49] = location;
    $[50] = t8;
  } else {
    t8 = $[50];
  }
  const memoizedValue = t8;
  const t9 = components[drop.drop_type];
  let t10;
  if ($[51] !== memoizedValue || $[52] !== t9) {
    t10 = <DropContext.Provider value={memoizedValue}>{t9}</DropContext.Provider>;
    $[51] = memoizedValue;
    $[52] = t9;
    $[53] = t10;
  } else {
    t10 = $[53];
  }
  return t10;
}